export default {
  assignedToMe: 'Assigned to me',
  selectInReviewState: 'Select tasks for review',
};
